module.exports = __webpack_public_path__ + "static/media/activobank.c35a2ac8.webp";